var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from "react";
import { useSelector } from "react-redux";
// Components
import InputComponent from "../InputComponent";
import PurchaseFee from "../PurchaseFee";
import FileUploadComponent from "../FileUploadComponent";
import AccordionComponent from "../AccordionComponent";
import ClientDetails from "../ClientDetails";
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { ONE_THOUSAND_CRORE_RUPEE } from "../../constants";
import { formatIndiaNumber } from "../../utils";
var TransferComponent = function (_a) {
    //
    var arnTransfer = useSelector(function (state) { return state.markets.payment; }).arnTransfer;
    var handleAmountChange = useCallback(function (event) {
        var _a, _b;
        var value = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        var formattedValue = value.replace(/,/g, "");
        var newValue = formatIndiaNumber(formattedValue);
        var numericValue = Number(value === null || value === void 0 ? void 0 : value.split(",").join(""));
        if (numericValue <= ONE_THOUSAND_CRORE_RUPEE) {
            aifPmsDi.payment.updateARNTransferValues(__assign(__assign({}, arnTransfer), { amount: newValue == "0" ? "" : newValue }));
        }
    }, [arnTransfer]);
    var handleKeyPress = function (event) {
        var charCode = event.charCode || event.keyCode;
        if ((charCode >= 48 && charCode <= 57) || charCode === 44) {
            return true;
        }
        event.preventDefault();
    };
    var handleTransferInChange = useCallback(function (event) {
        var _a, _b;
        var value = (_b = (_a = event.target) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : "";
        aifPmsDi.payment.updateARNTransferValues(__assign(__assign({}, arnTransfer), { transferIn: value }));
    }, [arnTransfer]);
    return (React.createElement("div", { className: "rounded auto-height width-375 position-relative " },
        React.createElement("div", { className: "bg-white px-3 py-4-custom rounded box-shadow-light" },
            React.createElement(ClientDetails, null),
            React.createElement("form", { className: "p-top-20 form" },
                React.createElement(InputComponent, { label: "Transfer In", placeholder: "Enter transfer in here", name: "transferIn", value: arnTransfer.transferIn, onChangeEvent: handleTransferInChange, required: true, helperText: "" }),
                React.createElement(InputComponent, { label: "Amount", placeholder: "Enter amount here", helperText: "", name: "amount", required: true, value: arnTransfer.amount, onChangeEvent: handleAmountChange, onKeyPress: handleKeyPress }))),
        React.createElement(AccordionComponent, { items: [
                {
                    header: "Set Purchase Fees & Charges",
                    body: React.createElement(PurchaseFee, null),
                    optional: true,
                    leftIcon: "edel-icon-bars",
                },
                {
                    header: "Upload Declaration",
                    body: React.createElement(FileUploadComponent, { fileSize: 5 }),
                    optional: false,
                    leftIcon: "edel-icon-medal-bookmark",
                },
            ] })));
};
export default React.memo(TransferComponent);
